/* Front end only styles/scripts */
import "../styles/style.scss";

document.addEventListener("DOMContentLoaded", function () {
    // Select all outline buttons that have an inline style attribute
    const buttons = document.querySelectorAll('.wp-block-button.is-style-outline .wp-element-button[style*="color"]');

    buttons.forEach(btn => {
        // Get the inline text color
        const inlineColor = btn.style.color;

        console.log('added');

        // If a color exists, set it as a CSS variable and mark the button
        if (inlineColor) {
            btn.style.setProperty('--custom-hover-bg', inlineColor);
            btn.classList.add('has-custom-hover-fix');
        }
    });
});